export default {
    // Retouner le Tag Google analytics par �cole
    getIdTagGoogleParEcole() {
        if (document.location.href.endsWith('/ece') || document.location.href.endsWith('/ece/') || document.location.href.includes('/ece?')) {
            return "GTM-M9B4RGV"
        }
        if (document.location.href.endsWith('/bachelorsesce') || document.location.href.endsWith('/bachelorsesce/') || document.location.href.includes('/bachelorsesce?')
            || document.location.href.endsWith('/reboostesce') || document.location.href.endsWith('/reboostesce/') || document.location.href.includes('/reboostesce?')
            || document.location.href.endsWith('/mscesce') || document.location.href.endsWith('/mscesce/') || document.location.href.includes('/mscesce?')
            || document.location.href.endsWith('/rentreedecaleeesce') || document.location.href.endsWith('/rentreedecaleeesce/') || document.location.href.includes('/rentreedecaleeesce?')
            || document.location.href.endsWith('/phdesce') || document.location.href.endsWith('/phdesce/') || document.location.href.includes('/phdesce?')
            || document.location.href.endsWith('/dbaesce') || document.location.href.endsWith('/dbaesce/') || document.location.href.includes('/dbaesce?')) {
            return "GTM-NFHDS33"
        }
        if (document.location.href.endsWith('/ebs') || document.location.href.endsWith('/ebs/') || document.location.href.includes('/ebs?')
            || document.location.href.endsWith('/rentreedecaleeebs') || document.location.href.endsWith('/rentreedecaleeebs/') || document.location.href.includes('/rentreedecaleeebs?')) {
            return "GTM-W4J3NQ6"
        }
        if (document.location.href.endsWith('/ium') || document.location.href.endsWith('/ium/') || document.location.href.includes('/ium?')) {
            return "GTM-D7PR"
        }
        if (document.location.href.endsWith('/supcareer') || document.location.href.endsWith('/supcareer/') || document.location.href.includes('/supcareer?')
            || document.location.href.endsWith('/supcareervae') || document.location.href.endsWith('/supcareervae/') || document.location.href.includes('/supcareervae?')
            || document.location.href.endsWith('/supcareercourssoir') || document.location.href.endsWith('/supcareercourssoir/') || document.location.href.includes('/supcareercourssoir?')) {
            return "GTM-4WQJ"
        }
        if (document.location.href.endsWith('/supdecreation') || document.location.href.endsWith('/supdecreation/') || document.location.href.includes('/supdecreation?')) {
            return "GTM-KGLPKFP"
        }
        if (document.location.href.endsWith('/supdepub') || document.location.href.endsWith('/supdepub/') || document.location.href.includes('/supdepub?')) {
            return "GTM-SWKG"
        }
        if (document.location.href.endsWith('/heip') || document.location.href.endsWith('/heip/') || document.location.href.includes('/heip?')) {
            return "GTM-KK6LWHZ"
        }
        if (document.location.href.endsWith('/bbainseec') || document.location.href.endsWith('/bbainseec/') || document.location.href.includes('/bbainseec?')
            || document.location.href.endsWith('/mastersinseec') || document.location.href.endsWith('/mastersinseec/') || document.location.href.includes('/mastersinseec?')
            || document.location.href.endsWith('/inseecbba') || document.location.href.endsWith('/inseecbba/') || document.location.href.includes('/inseecbba?')
            || document.location.href.endsWith('/bachelorsinseec') || document.location.href.endsWith('/bachelorsinseec/') || document.location.href.includes('/bachelorsinseec?')
            || document.location.href.endsWith('/isbe') || document.location.href.endsWith('/isbe/') || document.location.href.includes('/isbe?')
            || document.location.href.endsWith('/inseecbts') || document.location.href.endsWith('/inseecbts/') || document.location.href.includes('/inseecbts?')) {
            return "GTM-PXWR"
        }
        if (document.location.href.endsWith('/ceds') || document.location.href.endsWith('/ceds/') || document.location.href.includes('/ceds?')) {
            return "GTM-5C9X29F"
        }
        if (document.location.href.endsWith('/international') || document.location.href.endsWith('/international/') || document.location.href.includes('/international?')) {
            return "GTM-NHHF38"
        }

        // Si formulaire inconuu on retourne 'tagGoogleVide'
        return null
    },

    // Retouner le Tag Eulerian par �cole
    getIdTagEulerianParEcole() {
        if (document.location.href.endsWith('/ece') || document.location.href.includes('/ece?')) {
            return "xnt4.ece.fr"
        }
        if (document.location.href.endsWith('/bachelorsesce') || document.location.href.endsWith('/bachelorsesce/') || document.location.href.includes('/bachelorsesce?')
            || document.location.href.endsWith('/reboostesce') || document.location.href.endsWith('/reboostesce/') || document.location.href.includes('/reboostesce?')
            || document.location.href.endsWith('/mscesce') || document.location.href.endsWith('/mscesce/') || document.location.href.includes('/mscesce?')
            || document.location.href.endsWith('/rentreedecaleeesce') || document.location.href.endsWith('/rentreedecaleeesce/') || document.location.href.includes('/rentreedecaleeesce?')
            || document.location.href.endsWith('/phdesce') || document.location.href.endsWith('/phdesce/') || document.location.href.includes('/phdesce?')
            || document.location.href.endsWith('/dbaesce') || document.location.href.endsWith('/dbaesce/') || document.location.href.includes('/dbaesce?')) {
            return "fpb8.esce.fr"
        }
        if (document.location.href.endsWith('/ebs') || document.location.href.endsWith('/ebs/') || document.location.href.includes('/ebs?')
            || document.location.href.endsWith('/rentreedecaleeebs') || document.location.href.endsWith('/rentreedecaleeebs/') || document.location.href.includes('/rentreedecaleeebs?')) {
            return "csv4.ebs-paris.fr"
        }
        if (document.location.href.endsWith('/ium') || document.location.href.endsWith('/ium/') || document.location.href.includes('/ium?')) {
            return "xfn6.monaco.edu"
        }
        if (document.location.href.endsWith('/supcareer') || document.location.href.endsWith('/supcareer/') || document.location.href.includes('/supcareer?')
            || document.location.href.endsWith('/supcareervae') || document.location.href.endsWith('/supcareervae/') || document.location.href.includes('/supcareervae?')
            || document.location.href.endsWith('/supcareercourssoir') || document.location.href.endsWith('/supcareercourssoir/') || document.location.href.includes('/supcareercourssoir?')) {
            return "hjc6.supcareer.com"
        }
        if (document.location.href.endsWith('/supdecreation') || document.location.href.endsWith('/supdecreation/') || document.location.href.includes('/supdecreation?')) {
            return "tvl8.supdecreation.com"
        }
        if (document.location.href.endsWith('/supdepub') || document.location.href.endsWith('/supdepub/') || document.location.href.includes('/supdepub?')) {
            return "kyo7.supdepub.com"
        }
        if (document.location.href.endsWith('/heip') || document.location.href.endsWith('/heip/') || document.location.href.includes('/heip?')) {
            return "dxe2.heip.fr"
        }
        if (document.location.href.endsWith('/ceds') || document.location.href.endsWith('/ceds/') || document.location.href.includes('/ceds?')) {
            return "edu3.ceds.fr"
        }
        if (document.location.href.endsWith('/isbe') || document.location.href.endsWith('/isbe/') || document.location.href.includes('/isbe?')
            || document.location.href.endsWith('/bachelorsinseec') || document.location.href.endsWith('/bachelorsinseec/') || document.location.href.includes('/bachelorsinseec?')
            || document.location.href.endsWith('/bbainseec') || document.location.href.endsWith('/bbainseec/') || document.location.href.includes('/bbainseec?')
            || document.location.href.endsWith('/mastersinseec') || document.location.href.endsWith('/mastersinseec/') || document.location.href.includes('/mastersinseec?')
            || document.location.href.endsWith('/inseecbba') || document.location.href.endsWith('/inseecbba/') || document.location.href.includes('/inseecbba?')
            || document.location.href.endsWith('/inseecbts') || document.location.href.endsWith('/inseecbts/') || document.location.href.includes('/inseecbts?')) {
            return "ngi6.inseec.com"
        }
        if (document.location.href.endsWith('/international') || document.location.href.endsWith('/international/') || document.location.href.includes('/international?')) {
            "why3.inseec.education"
        }

        return null
    },

    // Retouner le Tag AbTasty par �cole
    getIdTagAbTastyParEcole() {
        if (document.location.href.endsWith('/ece') || document.location.href.includes('/ece?')) {
            return "274851b397253457e430fbc4def0bd08"
        }
        if (document.location.href.endsWith('/bachelorsesce') || document.location.href.endsWith('/bachelorsesce/') || document.location.href.includes('/bachelorsesce?')
            || document.location.href.endsWith('/reboostesce') || document.location.href.endsWith('/reboostesce/') || document.location.href.includes('/reboostesce?')
            || document.location.href.endsWith('/mscesce') || document.location.href.endsWith('/mscesce/') || document.location.href.includes('/mscesce?')
            || document.location.href.endsWith('/rentreedecaleeesce') || document.location.href.endsWith('/rentreedecaleeesce/') || document.location.href.includes('/rentreedecaleeesce?')) {
            return "937eb01912d4099921746ff755957b66"
        }
        if (document.location.href.endsWith('/ebs') || document.location.href.endsWith('/ebs/') || document.location.href.includes('/ebs?')
            || document.location.href.endsWith('/rentreedecaleeebs') || document.location.href.endsWith('/rentreedecaleeebs/') || document.location.href.includes('/rentreedecaleeebs?')) {
            return "e8e5188726a14fb2737c7f8d7a4d8bad"
        }
        if (document.location.href.endsWith('/ium') || document.location.href.endsWith('/ium/') || document.location.href.includes('/ium?')) {
            return "0de91c2649c81256ec668bf3ef07f4b3"
        }
        if (document.location.href.endsWith('/supcareer') || document.location.href.endsWith('/supcareer/') || document.location.href.includes('/supcareer?')) {
            return "de63b0b3f13b2ae4b74a0aa27612eb43"
        }
        if (document.location.href.endsWith('/supcareervae') || document.location.href.endsWith('/supcareervae/') || document.location.href.includes('/supcareervae?')
            || document.location.href.endsWith('/supcareercourssoir') || document.location.href.endsWith('/supcareercourssoir/') || document.location.href.includes('/supcareercourssoir?')) {
            return "34c597aa7e2b8e2226ffe97da4a9622e"
        }
        if (document.location.href.endsWith('/supdecreation') || document.location.href.endsWith('/supdecreation/') || document.location.href.includes('/supdecreation?')) {
            return "5e276d4b7c1ac8c3b0f6ce1d0e948bf7"
        }
        if (document.location.href.endsWith('/supdepub') || document.location.href.endsWith('/supdepub/') || document.location.href.includes('/supdepub?')) {
            return "cad6c8f9c8cf2ee76f64fe910f4776a5"
        }
        if (document.location.href.endsWith('/heip') || document.location.href.endsWith('/heip/') || document.location.href.includes('/heip?')) {
            return "9c749c3a9d8918acff9456e16a012ea3"
        }
        //if (document.location.href.endsWith('/ceds') || document.location.href.endsWith('/ceds/') || document.location.href.includes('/ceds?')) {
        //    return ""
        //}
        if (document.location.href.endsWith('/bachelorsinseec') || document.location.href.endsWith('/bachelorsinseec/') || document.location.href.includes('/bachelorsinseec?')) {
            return "88bde2710aa40f19f24a816748fbdc66"
        }
        if (document.location.href.endsWith('/inseecbba') || document.location.href.endsWith('/inseecbba/') || document.location.href.includes('/inseecbba?')) {
            return "bba61ba1ac4d0e423ff70701bbcc13ae"
        }
        if (document.location.href.endsWith('/isbe') || document.location.href.endsWith('/isbe/') || document.location.href.includes('/isbe?')) {
            return "9ec01651479869bc9957f322fc9c20f4"
        }
        if (document.location.href.endsWith('/mastersinseec') || document.location.href.endsWith('/mastersinseec/') || document.location.href.includes('/mastersinseec?')) {
            return "6235059f763628f1d7ebc4e11fad9280"
        }
        if (document.location.href.endsWith('/international') || document.location.href.endsWith('/international/') || document.location.href.includes('/international?')) {
            "f4a947e1009c3af8ef59ebd81be9f16d"
        }
        return null
    },

    // V�rifier si la date est dans le format GMT ex : 2003-06-17T22:00:00.000Z
    verifierDateFormatGMT(dateTest) {
        if (dateTest == null || dateTest == '') {
            return false
        }

        // supprimer la duplication des " suite au stringify
        dateTest = dateTest.replace('"', '').replace('"', '')

        if (dateTest.endsWith('T', 11) && dateTest.endsWith('Z', 24)) {
            return true;
        }
        else {
            return false
        }
    },

    // Encoder en bae 64
    utf8_to_b64(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    },

    // Decoder en base 64
    b64_to_utf8(str) {
        return decodeURIComponent(escape(window.atob(str)));
    }
}
